"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var __1 = require("../../../");

var form_1 = require("../../../form");

var style_1 = require("../style");

var InstanceForm = function InstanceForm(_ref) {
  var onSubmit = _ref.onSubmit,
      onSuccess = _ref.onSuccess;

  var _react_1$useState = react_1.useState(''),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      instanceName = _react_1$useState2[0],
      setInstanceName = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(false),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      error = _react_1$useState4[0],
      setError = _react_1$useState4[1];

  var handleChange = function handleChange(field) {
    if (typeof field.value === 'string') {
      setInstanceName(field.value);
    }
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    onSubmit(instanceName).then(onSuccess).catch(function (error) {
      setError(true);
    });
  };

  return react_1.default.createElement("form", {
    onSubmit: handleSubmit
  }, error && react_1.default.createElement(style_1.Error, {
    role: "alert"
  }, "We could not find an instance with this name."), react_1.default.createElement(form_1.Wrapper, {
    label: "Instance",
    name: "instance"
  }, react_1.default.createElement(form_1.Input, {
    name: "instance",
    onChange: handleChange
  })), react_1.default.createElement(__1.SubmitButton, {
    label: "Next"
  }));
};

exports.default = InstanceForm;